export const isFreelanceLeague = (leagueName: string): boolean =>
  (leagueName ?? '').toLowerCase().includes('freelance');
